import { fetchCompetitions, fetchTeams } from "../../api/index.js";
import { discipline_all, season_all } from "../../bdd/bddSTUB.js";
import { PERMISSIONS } from "../../permissions/permissionKeys.js";

export const availableFilters = {
    provider: {
      label: "Groupe",
      fetchFunction: null, // Pas d'appel API ici car récupéré via Redux
      getOptions: (groups) => groups.map((group) => ({
        value: group._id,
        label: group.name
      })).sort((a,b) => a.label.localeCompare(b.label)),
      dependencies: [], // Pas de dépendance
      disabled: () => false, // Toujours activé
      permissionKey : PERMISSIONS.FILTER_PROVIDER
    },
    discipline: {
      label: "Discipline",
      fetchFunction: null, // Données statiques
      getOptions: () => discipline_all.map((discipline) => ({
        value: discipline._id,
        label: discipline.name
      })).sort((a,b) => a.label.localeCompare(b.label)),
      dependencies: [], // Pas de dépendance
      disabled: () => false,
    },
    season: {
      label: "Saison",
      fetchFunction: null, // Données statiques
      getOptions: () => season_all.map((season) => ({
        value: season._id,
        label: season.name
      })),
      dependencies: [], // Pas de dépendance
      disabled: () => false,
    },
    competition: {
      label: "Compétition",
      fetchFunction: fetchCompetitions, // Appel API
      getOptions: (competitions) => competitions.map((competition) => ({
        value: competition._id,
        label: competition.name
      })),
      dependencies: ['provider', 'discipline', 'season'], // Dépend des filtres 'provider', 'discipline' et 'season'
      disabled: (filters) => !filters.provider || !filters.discipline || !filters.season, // Désactivé si les dépendances ne sont pas valorisées
    },
    teams: {
      label: "Équipe",
      fetchFunction: fetchTeams, // Appel API
      getOptions: (teams) => teams.map((team) => ({
        value: team._id,
        label: team.name
      })),
      dependencies: ['competition'], // Dépend uniquement de 'competition'
      disabled: (filters) => !filters.competition, // Désactivé si la compétition n'est pas valorisée
    },
  };